import shortcutRegistry from '.'

declare global {
	interface Window {
		ShortcutRegistry: typeof shortcutRegistry | null
	}
}

window.ShortcutRegistry = shortcutRegistry
